export default "__VITE_ASSET__6debefc9__"